import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { ArticleService } from './article.service';
import { API_MAP } from '../../../core/helpers/api.map';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const ArticleResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(ArticleService)
    .get(API_MAP.article + removeQueryParams(state.url).substring(1))
    .pipe(map(() => true));
};
